/** @format */

export function caseUnsensitiveEquals(a?: string, b?: string) {
  return a?.toLowerCase() === b?.toLowerCase();
}
